import { Typography, Box, Stack } from '@mui/material';
import credibledCheck from '../../../assets/img/credibled_check.gif';

export default function ConsumerPoliceCheckCompleted() {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				minHeight: '70vh',
				textAlign: 'center',
				padding: 4,
			}}
		>
			<Stack
				spacing={3}
				alignItems='center'
			>
				<Typography
					variant='h3'
					className='text-primary'
					sx={{
						fontWeight: 'bold',
						mb: 2,
					}}
				>
					You're all set! <br />
					Your details have been submitted successfully.
				</Typography>

				<img
					src={credibledCheck}
					alt='Success checkmark'
					style={{ width: '150px', height: '150px', marginBottom: '2rem' }}
				/>

				<Typography
					variant='body1'
					sx={{
						fontSize: '1.1rem',
						color: 'text.secondary',
						mt: 4,
					}}
				>
					Nothing left to do — go ahead and close this tab
				</Typography>
			</Stack>
		</Box>
	);
}
